import { IReduxState } from 'types/redux';

export const isSidebarCollapsedSelector = (state: IReduxState) => state.context.sidebarCollapsed;
